<app-side-nav class="container-size"></app-side-nav>

<section class="legal-page">
  <section [class.is-right]="isRight">
    <img
      class="mobile-back-to-main"
      src="assets/img/icons/contact/mobile_arrow_back.svg"
      alt="Zurück zur Startseite"
      role="button"
      tabindex="0"
      (click)="backToMain()"
      (keydown.enter)="backToMain()"
      (keydown.space)="backToMain()"
    />
    <section class="legal" id="legal-left">
      <div class="legal-position">
        <div class="legal-sideline-container">
          <h1 class="header-txt">{{ "legal.title" | translate }}</h1>
        </div>
        <div class="legal-txt-container">
          <div class="legal-section">
            <h2>{{ "legal.imprint" | translate }}</h2>
            <ul>
              <li>{{ "legal.names_list" | translate }}</li>
              <li>{{ "legal.address" | translate }}</li>
              <li>{{ "legal.postcode_city" | translate }}</li>
            </ul>
          </div>
          <div class="legal-section">
            <p>
              {{ "legal.exploring" | translate }} <br />
              {{ "legal.email_label" | translate }}
            </p>
          </div>
          <div class="legal-section">
            <p>
              <span class="color">{{ "legal.acceptance" | translate }}</span
              ><br />
              {{ "legal.acceptance_text" | translate }}
            </p>
          </div>

          <div class="legal-section">
            <p>
              <span class="color">{{ "legal.scope" | translate }}</span
              ><br />
              {{ "legal.scope_text_1" | translate }}
            </p>
            <p>
              {{ "legal.scope_text_2" | translate }}
            </p>
          </div>
          <div class="legal-section">
            <p>
              <span class="color">{{ "legal.proprietary" | translate }}</span
              ><br />
              {{ "legal.proprietary_text" | translate }}
            </p>
          </div>
        </div>
      </div>
      <img
        class="next-arrow"
        src="assets/img/icons/arrows/arrow_right.png"
        alt="Weiter"
        role="button"
        tabindex="0"
        (click)="goRight()"
        (keydown.enter)="goRight()"
        (keydown.space)="goRight()"
      />
    </section>

    <section class="legal legal-right" id="legal-right">
      <div class="legal-position-right">
        <div class="legal-txt-container">
          <div class="legal-section">
            <p>
              <span class="color">{{ "legal.use_of_product" | translate }}</span
              ><br />
              {{ "legal.use_of_product_text" | translate }}
            </p>
          </div>

          <div class="legal-section">
            <p>
              <span class="color">{{ "legal.disclaimer" | translate }}</span
              ><br />
              {{ "legal.disclaimer_text" | translate }}
            </p>
          </div>

          <div class="legal-section">
            <p>
              <span class="color">{{ "legal.indemnity" | translate }}</span
              ><br />
              {{ "legal.indemnity_text" | translate }}
            </p>
          </div>
          <p>
            {{ "legal.contact_line" | translate }}<br /><br />
            {{
              "legal.date"
                | translate : { date: (today | date : "dd. MMMM yyyy") }
            }}
          </p>
        </div>
      </div>

      <section class="info-side">
        <ul class="contacts">
          <li>
            <div class="email-container">
              <img
                class="emailImg"
                src="assets/img/icons/contact/eMail_contact.svg"
                alt="E-Mail Icon"
              />
              <a class="emailLink" href="mailto:ebubekir.elicora@gmx.de"
                >E-Mail: ebubekir.elicora&#64;gmx.de</a
              >
            </div>
          </li>
          <li>
            <div class="phone-container">
              <img
                class="phoneImg"
                src="assets/img/icons/contact/phone_contact.svg"
                alt="Telefon Icon"
              />
              <a class="phoneLink" href="tel:+491714155340"
                >Tel: 0171 4155340
              </a>
            </div>
          </li>
        </ul>
        <div class="container-legal-notice">
          <div class="legal-notice-pos">
            <a class="legal-a" routerLink="/legal" (click)="onLegalClick()">
              {{ "contact.footer.legal" | translate }}
            </a>
            <a class="policy-a" routerLink="/privacy">{{
              "legal.footer_privacy" | translate
            }}</a>
            <p>&copy; Ebubekir Elicora 2025</p>
          </div>
        </div>
      </section>
      <img
        class="back-arrow"
        src="assets/img/icons/arrows/arrow_left.png"
        alt="Zurück"
        role="button"
        tabindex="0"
        (click)="goLeft()"
        (keydown.enter)="goLeft()"
        (keydown.space)="goLeft()"
      />
      <div class="legal-accent-layer">
        <div class="accent-bar" aria-hidden="true"></div>
      </div>
    </section>
    <section class="legal-bottom-section mobile-container">
      <div class="mobile-size">
        <div class="social-container mobile-arrow">
          <img
            class="back-arrow-mobile"
            src="assets/img/icons/arrows/arrow_left.png"
            alt="Nach oben"
            role="button"
            tabindex="0"
            (click)="scrollToTopMobile()"
            (keydown.enter)="scrollToTopMobile()"
            (keydown.space)="scrollToTopMobile()"
          />
        </div>
        <nav class="mobile-social" aria-label="social">
          <div class="top-links">
            <a
              href="https://github.com/DEIN_GITHUB"
              target="_blank"
              rel="noopener"
              aria-label="GitHub"
              class="icon"
            >
              <img
                class="base"
                src="assets/img/icons/social_media/gitHub.svg"
                alt="GitHub"
              />
              <img
                class="hover"
                src="assets/img/icons/social_media/gitHub_hover.svg"
                alt=""
                aria-hidden="true"
              />
            </a>
            <a href="mailto:you@example.com" aria-label="E-Mail" class="icon">
              <img
                class="base"
                src="assets/img/icons/social_media/eMail.svg"
                alt="Mail"
              />
              <img
                class="hover"
                src="assets/img/icons/social_media/eMail_hover.svg"
                alt=""
                aria-hidden="true"
              />
            </a>
            <a
              href="https://www.linkedin.com/in/DEIN_LINKEDIN"
              target="_blank"
              rel="noopener"
              aria-label="LinkedIn"
              class="icon"
            >
              <img
                class="base"
                src="assets/img/icons/social_media/linkedIn.svg"
                alt="LinkedIn"
              />
              <img
                class="hover"
                src="assets/img/icons/social_media/linkedIn_hover.svg"
                alt=""
                aria-hidden="true"
              />
            </a>
          </div>
        </nav>
      </div>

      <div class="container-legal-notice mobile-legal">
        <div class="brand">
          <a
            class="brand-hit nav-link"
            href="#about"
            [attr.aria-label]="'nav.brand_about_aria' | translate"
          ></a>
          <svg
            class="brand-arc"
            viewBox="0 0 160 110"
            width="140"
            height="110"
            aria-hidden="true"
          >
            <path
              id="brandArcPath"
              d="M 20 90 A 62 100 0 0 1 140 90"
              fill="none"
            />
            <text class="brand-arc-text">
              <textPath
                href="#brandArcPath"
                startOffset="50%"
                text-anchor="middle"
                letter-spacing="-1"
              >
                {{ "nav.brand_arc" | translate }}
              </textPath>
            </text>
          </svg>
          <h1>EE</h1>
        </div>

        <div class="legal-notice-pos">
          <p>&copy; Ebubekir Elicora 2025</p>
          <div class="legal-policy-mobile-container">
            <a class="legal-a" routerLink="/legal" (click)="onLegalClick()">
              {{ "contact.footer.legal" | translate }}
            </a>
            <a class="policy-a" routerLink="/privacy">{{
              "contact.footer.policy" | translate
            }}</a>
          </div>
        </div>
      </div>
    </section>
  </section>
</section>
